import { Link } from '@app/core';
import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Session, StudyType } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  link: {
    ...theme.fonts.h5,
    color: theme.colors.blueAccessible,
  },
  icon: {
    marginLeft: theme.marginBase,
  },
}));

interface Props {
  session: Session;
}

export const EditSessionLayoutSidePanelFooter = ({ session }: Props) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const helpDeskLink = useMemo(() => {
    if (session.studyType === StudyType.MODERATED) {
      return i18n.language === 'fr'
        ? 'https://tandemz.crisp.help/fr/article/comment-lancer-une-session-1mh6ege/'
        : 'https://tandemz.crisp.help/en/article/launching-a-study-on-tandemz-1j9wxgb/';
    }
    return 'https://tandemz.crisp.help/en/article/how-do-i-set-up-my-unmoderated-recruitment-session-1bp4jkj/?bust=1682705295412';
  }, [i18n.language]);

  return (
    <div className={classes.container}>
      <Link
        className={classes.link}
        rel="noopener noreferrer"
        target="_blank"
        href={helpDeskLink}
      >
        {t('helpDesk')}
        <i className={classnames('ri-share-box-line', classes.icon)}></i>
      </Link>
    </div>
  );
};
